import { ReCaptcha as SharedReCaptcha } from "@epc-front/shared/components/ReCaptcha";

import { apiKeys } from "../../app/services/apiKeys";

export const ReCaptcha = () => (
  <SharedReCaptcha apiKey={apiKeys.value.reCaptcha} />
);
